import { render, staticRenderFns } from "./roleDetail.vue?vue&type=template&id=0e66310c&scoped=true&"
import script from "./roleDetail.vue?vue&type=script&lang=js&"
export * from "./roleDetail.vue?vue&type=script&lang=js&"
import style0 from "./roleDetail.vue?vue&type=style&index=0&id=0e66310c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e66310c",
  null
  
)

export default component.exports